export const default_content = {
  media_type: "",
  media_url: "",
  title: "",
  content: "",
  type: "",
  topic: "",
};

export const default_tags = {
  hot_topic: "",
  event_tag: "",
  product_tag: "",
  article_tag: "",
};



// WEBPACK FOOTER //
// ./src/screens/Feeds/constants/default.js